import { React } from "react";
import { googleLogout } from "@react-oauth/google";
import { Link } from "react-router-dom";
import DropdownMenu from '../components/DropdownMenu';

function Navbar() {

  const handleLogout = () => {
    googleLogout();
    localStorage.removeItem("authenticated");
    window.location.reload();
  };

  return(
    <div className="container mx-auto mb-11">
      <nav className="bg-white border-gray-200 dark:bg-gray-900">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
              <img src="/GetPop Logo Pink-01.png" className="h-12" alt="GetPop Logo" />
              <span className="self-center text-2xl font-semibold whitespace-nowrap text-gray-700 dark:text-white">WorkBench</span>
          </a>
          <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-default" aria-expanded="false">
              <span className="sr-only">Open main menu</span>
              <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
              </svg>
          </button>
          <div className="hidden w-full md:block md:w-auto" id="navbar-default">
            <ul className="items-center font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
              <li>
                <Link to="/" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Home</Link>
              </li>
              <DropdownMenu
                label="Flavor Updaters"
                items={[
                  { label: "Flavors", to: "/flavor-updater" },
                  { label: "Flavor Profiles", to: "/flavor-profile-updater" }
                ]}
              />
              <li>
                <Link to="/tag-updater" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Tags Updater</Link>
              </li>
              <li>
                <Link to="/image-converter" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Image Converter</Link>
              </li>
              <DropdownMenu
                label="AI Updaters"
                items={[
                  { label: "Products Review", to: "/products/review" }
                ]}
              />
              <li>
                <Link to="/knowledge-base" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Knowledge Base</Link>
              </li>
              <li>
                <button className=" bg-indigo-500 text-white font-bold py-1 px-3 rounded-lg" onClick={handleLogout}>Sign Out</button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>  
  )
}

export default Navbar;